import type { ReactNode, Ref } from "react";

import { FixedTabTopBar } from "./FixedTabTopBar";

type TabPageShellProps = {
  fixed: ReactNode;
  children: ReactNode;
  className?: string;
  bodyRef?: Ref<HTMLElement>;
};

export function TabPageShell({ fixed, children, className = "", bodyRef }: TabPageShellProps) {
  return (
    <>
      <FixedTabTopBar>{fixed}</FixedTabTopBar>
      <main
        ref={bodyRef}
        className={`screen0-shell screen0-tab-body grid gap-6${className ? ` ${className}` : ""}`}
      >
        {children}
      </main>
    </>
  );
}
